<template>
    <div id="apply-grade-to-modal" class="hidden modal-new">
        <btnClose/>
        <span class="title">Apply Grade To</span>

        <div class="modal-body-container">
            <div v-for="bin of applyGradeToProjectTree" :key="bin.key" class="bin-container">
                <v-expansion-panels :value="expanded" accordion>
                    <v-expansion-panel expand>
                        <v-expansion-panel-header>
                            <span class="bin-name">{{ bin.name }}</span>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <div class="assets-container">
                                <div v-for="asset of bin.children" :key="asset.key" class="asset-container">
                                    <v-lazy>
                                        <Thumbnail :item="asset" @click.native="selectedItem = asset" :class="{ '--selected': selectedItem && selectedItem.key == asset.key }" />
                                    </v-lazy>
                                    <span class="asset-name">{{ nicename(asset.name) }}</span>
                                </div>
                            </div>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </div>
        </div>

        <div class="buttons-continer">
            <button
                :class="{ '--disabled': inProcess }"
                :disabled="!active.length && !selectedItem"
                class="modal-btn --primary"
                type="button"
                @click="onConfirm"
            >
                <v-progress-circular v-if="inProcess" color="#fff" indeterminate size="18" width="3"
                ></v-progress-circular>
                <span v-else>Apply</span>
            </button>
            <button class="modal-btn --cancel" type="button" @click="onCancel">Cancel</button>
        </div>
    </div>
</template>

<script>
import {mapActions, mapGetters, mapState} from "vuex";
import btnClose from "@/components/app/buttons/modal/Close";
import FilenameMixin from "@/mixins/Filename";
import Thumbnail from "@/components/app/projects/Thumbnail";

export default {
    mixins: [FilenameMixin],

    components: {
        btnClose,
        Thumbnail
    },

    data() {
        return {
            active: [],
            openBins: [],
            selectedItem: null,
            inProcess: false,
            expanded: 0,
        };
    },
    computed: {
        ...mapState("Projects", ["applyGradeToProjectTree"]),
        ...mapGetters("Projects", ["thumbnail"]),

        assetType() {
            return this.$store.state.Projects.action.type;
        },
    },

    methods: {
        ...mapActions("Helpers", ["revokeObjectURL"]),

        nicename(name, stripTimestampOnly = false) {
            if (stripTimestampOnly) return this.stripTimestamp(name);
            else return this.stripTimestampAndExtension(name);
        },

        onSelection(items) {
            this.active = items;
        },

        async onConfirm() {
            if (this.inProcess) return;
            this.inProcess = true;
            vm.$store.dispatch("Loader/showProgressBar", "indeterminate");

            await this.applyGrade();

            vm.$store.dispatch("Loader/showProgressBar", false);

            this.inProcess = false;
            window.UI.hideModal();
            this.active = [];
            this.selectedItem = null;
            this.openBins = [];
        },

        async applyGrade() {
            await window.lutify.storeLastState();

            let sourceAssetFile = this.$store.state.Projects.action.data;
            let sourceAssetData;

            if (this.assetType == "candidate") {
                sourceAssetData = await window.lutify.fetchCandidate(sourceAssetFile);
            } else if (this.assetType == "match") {
                sourceAssetData = await window.lutify.fetchMatch(sourceAssetFile);
            }

            let blocks = [...sourceAssetData.blocks];
            let lastState = await window.lutify.fetchLastState(this.selectedItem.id);
            blocks[1] = lastState.blocks[1];
            blocks[blocks.length - 1] = lastState.blocks[lastState.blocks.length - 1];

            if (this.selectedItem.id == this.$store.state.Projects.image) {
                await window.lutify.applyCompare(blocks, "waitToLoad", false);
                if (loader.typeOfActiveMedia('raw') && sourceAssetData.rawDevelopment) {
                    vm.rawDevelopment.setValues(sourceAssetData.rawDevelopment)
                    await vm.rawDevelopment.developAndRender()
                }
            } else {
                if (sourceAssetData.rawDevelopment) {
                    await window.lutify.storeLastState(this.selectedItem.id, blocks, false, sourceAssetData.rawDevelopment);
                } else {
                    await window.lutify.storeLastState(this.selectedItem.id, blocks);
                }
            }
        },

        onCancel() {
            window.UI.hideModal();
            this.active = [];
            this.openBins = [];
            this.selectedItem = null;
        },
    },
};
</script>

<style lang="scss">
#apply-grade-to-modal {
    width: 50%;
    height: 80%;

    .buttons-continer {
        margin-top: auto;
    }

    .modal-body-container {
        margin-bottom: 50px;
        overflow-y: scroll;
        scrollbar-color: #989898 transparent;
        scrollbar-width: thin;

        &::-webkit-scrollbar {
            width: 5px;
        }

        &::-webkit-scrollbar-thumb {
            background-color: #989898;
            border-radius: 50px;
        }
    }

    .v-expansion-panel {
        background: transparent;
        color: inherit;

        &:before {
            display: none;
        }

        .v-expansion-panel-header {
            padding: 0;
            min-height: auto;
            flex-direction: row-reverse;
            // margin-bottom: 10px;

            &:before {
                display: none;
            }

            span {
                font-size: 12px;
                font-weight: bold;
            }

            .v-expansion-panel-header__icon i {
                font-size: 18px;
                color: var(--font-default-color);
            }
        }

        .v-expansion-panel-content__wrap {
            margin-bottom: 60px;
            padding: 0;
        }
    }

    .bin-container {
        &:not(:first-of-type) {
            margin-top: 15px;
        }
    }

    .assets-container {
        margin-top: 15px;
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        grid-column-gap: 30px;
        grid-row-gap: 30px;
        padding-right: 10px;
        // margin-left: -3px;
        // margin-right: -3px;

        .asset-container {
            min-width: 0;

            .file-thumbnail {
                border-radius: var(--thumbnail-lg-border-radius);
                border: 3px solid transparent;

                &.--selected {
                    border: 3px solid var(--primary);
                }
            }

            .asset-name {
                line-height: 22px;
                font-size: 12px;
                height: 22px;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
                display: block;
            }
        }
    }
}

#project-tree-copy-to {
    margin-bottom: 50px;
    height: 300px;
    // scrollbar-width: none;
    background: transparent;
    color: #989898;
    font-size: 1rem !important;

    overflow-y: scroll;
    overflow-x: hidden;
    scrollbar-color: #989898 transparent;
    scrollbar-width: thin;

    &::-webkit-scrollbar {
        width: 5px;
    }

    &::-webkit-scrollbar-thumb {
        background-color: #989898;
        border-radius: 50px;
    }

    .v-icon {
        color: #989898;
    }

    .v-treeview-node__label {
        line-height: 1;
    }

    .v-treeview-node__root:before,
    .v-treeview-node__toggle {
        transition: none;
    }

    .v-treeview-node__toggle:after {
        display: none;
    }

    .thumbnail-container {
        width: 50px;
        height: 35px;
        margin-right: 5px;

        .file-thumbnail {
            width: 100%;
            height: 100%;
            object-fit: contain;
            padding: 3px 0;
            // border-radius: var(--thumbnail-sm-border-radius);
        }
    }
}
</style>
